// extracted by mini-css-extract-plugin
export var container = "_fc-1";
export var editor = "_fc-2";
export var resizable = "_fc-3";
export var wrapper = "_fc-0";